import useCurrentUser from 'src/store/user/useCurrentUser';

export const useIsCurrentUserExpert = () => {
  const user = useCurrentUser();

  return Boolean(user?.isExpert);
};
